import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import HomeIcon from '../icons/HomeIcon'
import WorkIcon from '../icons/WorkIcon'
import { SavedAddress } from '../../types/address'
import AddCircle from 'Components/icons/AddCircle'
import { AppDispatch, RootState } from 'store'
import { fetchInfluencerAddressesThunk } from 'slices/addressBook/thunk'
import { useParams } from 'react-router-dom'
import PlusIcon from 'assets/icons/PlusIcon'

interface AddressListProps {
    onAddNew: () => void
    onSelection?: (savedAddress: SavedAddress) => void
    selectedAddressUUID?: string | null
    showRecentlyAddedAddress?: boolean
    recentlyAddedAddress?: SavedAddress | null
}
const AddressList: React.FC<AddressListProps> = ({ onAddNew, onSelection, selectedAddressUUID, showRecentlyAddedAddress = false, recentlyAddedAddress }) => {

    const dispatch: AppDispatch = useDispatch();
    const { collaborationId, campaignId } = useParams();

    const collaboration = useSelector((state: RootState) => state.legacyCollaborations.items[campaignId!]?.[collaborationId!]);
    const influencerId = collaboration?.collaboration?.influencer?.uuid;
    const addressBook = useSelector((state: RootState) => state.addressBook.influencers[influencerId!]);

    const addressBookList = addressBook?.items ?? [];

    const [selectedAddress, setSelectedAddress] = useState<SavedAddress | null>(null);

    const fetchAddressBook = useCallback(() => {
        if (influencerId) {
            dispatch(fetchInfluencerAddressesThunk({ influencerId }));
        }
    }, [dispatch])

    useEffect(() => {
        fetchAddressBook();
    }, [dispatch, fetchAddressBook])

    const handleClick = (address: SavedAddress) => {
        setSelectedAddress(address);
    }

    useEffect(() => {
        if (selectedAddressUUID) {
            const selected = addressBookList.find(address => address.uuid === selectedAddressUUID);
            if (selected) {
                setSelectedAddress(selected);
            }
        }
    }, [selectedAddressUUID, addressBookList])

    useEffect(() => {
        if (recentlyAddedAddress) {
            setSelectedAddress(recentlyAddedAddress);
        }
    }, [recentlyAddedAddress])

    useEffect(() => {
        console.log(selectedAddress);
        if (onSelection && selectedAddress) onSelection(selectedAddress)
    }, [selectedAddress])


    return (
        <div className="addresses overflow-scroll">
            <div className="action-btns">
                <div className="address-action-btn" onClick={onAddNew}>
                    <PlusIcon />
                    Add New Address
                </div>
            </div>
            <div className="location-list">
                <span className="location-list-title">Saved Address</span>
                {
                    showRecentlyAddedAddress && recentlyAddedAddress && (
                        <div className="location-list-item cursor-pointer" onClick={() => handleClick(recentlyAddedAddress)} >
                            <div className="location-list-item-top">
                                <div className="gig-selection-checkbox-wrapper">
                                    <input
                                        type="checkbox"
                                        className="form-check-input gig-selection-check-input radio-check"
                                        checked={selectedAddress?.uuid === recentlyAddedAddress.uuid}
                                        onChange={() => setSelectedAddress(recentlyAddedAddress)}
                                    />
                                </div>
                                {recentlyAddedAddress.name === 'Home' ? <HomeIcon /> : (recentlyAddedAddress.name === 'Work' ? <WorkIcon /> : "")}
                                <span className="location-list-item-title">
                                    {recentlyAddedAddress.name}
                                </span>
                            </div>
                            <span className="location-list-item-address">
                                {recentlyAddedAddress.premise ? `${recentlyAddedAddress.premise},` : ''} {recentlyAddedAddress.sublocality ? `${recentlyAddedAddress.sublocality},` : ''} {recentlyAddedAddress.city ? `${recentlyAddedAddress.city},` : ''} {recentlyAddedAddress.region ? `${recentlyAddedAddress.region},` : ''} {recentlyAddedAddress.pincode}
                            </span>
                        </div>
                    )
                }
                {
                    addressBookList.map((address, i) => {
                        return (
                            <div className="location-list-item cursor-pointer" key={i} onClick={() => handleClick(address)} >
                                <div className="location-list-item-top">
                                    <div className="gig-selection-checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            className="form-check-input gig-selection-check-input radio-check"
                                            checked={selectedAddress?.uuid === address.uuid}
                                            onChange={() => setSelectedAddress(address)}
                                        />
                                    </div>
                                    {address.name === 'Home' ? <HomeIcon /> : (address.name === 'Work' ? <WorkIcon /> : "")}
                                    <span className="location-list-item-title">
                                        {address.name}
                                    </span>
                                </div>
                                <span className="location-list-item-address">
                                    {address.premise ? `${address.premise},` : ''} {address.sublocality ? `${address.sublocality},` : ''} {address.city ? `${address.city},` : ''} {address.region ? `${address.region},` : ''} {address.pincode}
                                </span>
                            </div>
                        )
                    })
                }
                {
                    !showRecentlyAddedAddress && addressBookList.length === 0 && (
                        <div className="location-list-item text-center mt-5 py-5 border border-dashed border-dark-gray rounded">
                            <span className="text-muted fs-12">No addresses found</span>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default AddressList